module.exports = __webpack_public_path__ + "img/showcase-activityreport-en-ca.c8e5aa9a.jpg";